import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=5051d80c&scoped=true&"
import script from "./Team.vue?vue&type=script&lang=js&"
export * from "./Team.vue?vue&type=script&lang=js&"
import style0 from "./Team.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Team.vue?vue&type=style&index=1&id=5051d80c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5051d80c",
  null
  
)

export default component.exports